import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    text: 'Descarga la guía inmediatamente después de la compra.'
  }, {
    num: '2',
    text: 'Lee el capítulo introductorio y aplica la primera lista de verificación esa misma noche.'
  }, {
    num: '3',
    text: 'Sigue el plan paso a paso durante las primeras 48 horas y ajusta según la edad de tu bebé.'
  }];
  return <section className="py-24" data-id="element-192">
      <div className="max-w-5xl mx-auto px-6" data-id="element-193">
        <FadeIn data-id="element-194">
          <div className="text-center mb-16" data-id="element-195">
            <h2 className="text-3xl md:text-4xl font-bold text-brown-dark mb-4" data-id="element-196">
              ¿Cómo funciona?
            </h2>
            <p className="text-lg text-brown/80 font-serif" data-id="element-197">
              Un proceso simple, directo y sin complicaciones.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-198">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-16 right-16 h-0.5 bg-accent/30 z-0" data-id="element-199"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} direction="up" className="relative z-10" data-id="element-200">
              <div className="flex flex-col items-center text-center" data-id="element-201">
                <div className="w-24 h-24 rounded-full bg-cream border-8 border-white shadow-soft flex items-center justify-center mb-6" data-id="element-202">
                  <span className="text-3xl font-serif font-bold text-accent" data-id="element-203">
                    {step.num}
                  </span>
                </div>
                <p className="text-lg text-brown-dark/80 px-4" data-id="element-204">{step.text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}